<template>
   <div class="container bg-white pt-5">
    <div class="row">
      <div class="col-md-4">
        <top-five-turnover></top-five-turnover>
      </div>
      <div class="col-md-4">
        <top-five-gainer></top-five-gainer>
      </div>
      <div class="col-md-4">
        <top-five-looser></top-five-looser>
      </div>
    </div>
  </div>
</template>

<script>
import TopFiveTurnover from './TopFiveTurnover.vue';
import TopFiveGainer from './TopFiveGainer.vue';
import TopFiveLooser from './TopFiveLooser.vue'
export default {
  components: {
    TopFiveTurnover,
    TopFiveGainer,
    TopFiveLooser
  }
  
};
</script>

<style></style>
